module.exports = __webpack_public_path__ + "media/scanCodeSuccess.fe208ca5.mp3";